import {useRef} from 'react';
import { Link } from 'react-router-dom';
import './ShortNewsDisplayer.css';
import SingleOffer from '../SingleOffer/SingleOffer';

import { useOffersToDisplay, useDetailedOffer } from '../../data/GlobalStates';
import { useAtom } from 'jotai';


const ShortNewsDisplayer = ({setRefresh}) => {

  const scrolledOffer = useRef(null);
   const containerRef = useRef(null);

  //stany globalne:
  const [ OffersToDisplay, setOffersToDisplay ] = useAtom(useOffersToDisplay);
  const [ DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);


   const ShortNewsDisplay = () => {
  
      return (
         <div className='OffersDisplayScrollableContainer' ref={containerRef}>
           <div className='ShortNewsMainContainer'>

       <>
       {
        OffersToDisplay.length ? 
            OffersToDisplay
            .sort((a, b) => new Date(b.addDate) - new Date(a.addDate))
            .slice(0,3)
            .map((offer, index) => (
              <SingleOffer
                 Images={offer.ImagesUrls || []}
                 key={offer.id}
                 offer={offer}
                 setDetailedOffer={setDetailedOffer}
                 setRefresh={setRefresh}
                 scrolledOffer={scrolledOffer}
                 dataIndex={index} 
                 id={`offer-${index}`}
                 />)) : ''
       }
       </>
                

           </div>
        
                
             <Link to='/Aktualnosci' className='NewsMainButton'>
               <span className=''>Zobacz wszystkie</span>
             </Link>

          </div>
      )
   };

    return (
    <div className='OffersDisplayMainContainer'> 
      {ShortNewsDisplay()}
    </div>
    )
};
export default ShortNewsDisplayer;

